<template>
	<Layout>
		<div class="banner" style="background-image: url(/design/sigofood-images/banner.jpg)" >
			<div>
				<h3>Restaurants Near You</h3>
				<h5>Best Deals at your Favorite Restaurants</h5>
			</div>
		</div>

		<div class="container-sm">
			<div class="row">
				<div class="col-xl-6 col-lg-6 col-md-6 p-2">

					<b-input-group class="mt-3 search">
    					<b-form-input placeholder="Search Restaurants" class="form-control" v-model="key" @keyup="searchRestaurants()"></b-form-input>
    					<b-input-group-append>
      					<b-button variant="outline-warning"><i class="material-icons">search</i></b-button>
    					</b-input-group-append>
  					</b-input-group>
				</div>

				<div class="col-xl-3 col-lg-3 col-md-6 py-4">
					<div class="btn-group d-flex cuisines-dropdown"  >
                  <select class="btn2 bg-white btn-lg dropdown-toggle w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false" v-model="c_id" @change="fetchRestaurants()">
                     <option value="">Cuisines</option>
                     <option :value="cuisine.c_id" v-for="cuisine in cuisines" :key="cuisine.c_id">
                                  {{cuisine.name}}</option>
                  </select>
               </div>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-6 py-4">
					<div class="btn-group d-flex filter-dropdown">
						<b-dropdown text="Sort" variant="outline-warning" class="bg-white w-100">
    						<b-dropdown-form>
    							<div class="form-check sort-check" v-if='restaurants' >
									<input type="checkbox" v-model="addShow"  value='AZ'    @change="sortedItems('AZ')">
									<label >A to Z</label>
								</div>
    						</b-dropdown-form>
    						<b-dropdown-form>
								<div class="form-check sort-check" v-if='restaurants'>
									<input type="checkbox"  v-model="addShow" value="Fastest" @change="sortedItems('Fastest')" >
									<label >Fastest Time</label>
								</div>
							</b-dropdown-form>
							<b-dropdown-form>
								<div class="form-check sort-check" v-if='restaurants'>
									<input type="checkbox"  v-model="addShow" value="Rating"  @change="sortedItems('Rating')" >
									<label >Ratings</label>    
								</div>
							</b-dropdown-form>
							<b-dropdown-form>
								<div class="form-check sort-check" v-if='restaurants'>
									<input type="checkbox"  v-model="addShow" value="Recommended"  @change="sortedItems('Recommended')">
									<label >Recommended  </label> 
								</div>
							</b-dropdown-form>
    					</b-dropdown>
					</div>
				</div>
			</div>
		</div><br>

		<div class="container-sm mb-5" v-if="this.key">
			<div class="row">
				<div class="col-xl-4 col-lg-4 col-md-6" v-for="restaurant in searchs" :key="restaurant.r_id">
					<div class="card mb-3 restaurant-card">
						<div class="rest-image">
							<router-link :to="{ name: 'restaurant-details ',params: {id: restaurant.r_id,branch_id: restaurant.branch_id } }" >
								<div v-if="restaurant.rest_image" class="restaurant-image"  :style="{ 'background-image': 'url(' + $image_url + restaurant.rest_image + ')' }"></div>
								<div v-else  class="restaurant-image" :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
							</router-link>
						</div>
						<div class="card-body">
							<div class="row">
							  	<div class="col">
									<h5 class="card-title" style="text-transform: capitalize;">
										{{ restaurant.rest_name }}
									</h5>
							  	</div>
							  	<div class="col-1 d-flex">
									<img src="/design/hungerline-images/food-delivery.png" style="width: 20px; height: 20px" />
							  	</div>
							  	<div class="col">						
									<p class="dtime">Within {{ restaurant.travel_time }} min</p>
															
							  	</div>
							</div>
							<p class="card-text restaurant-types"><span v-for="type in restaurant.types" :key="type.name">
							  							{{ type.name }}</span>
							</p>
							<div class="row ratings">
							 	<span v-if="restaurant.ratings >= 0 && restaurant.ratings < 1" > 
							 		<img src="/design/hungerline-images/happy.png" />Worst
							 	</span>
								<span v-if="restaurant.ratings>=1 && restaurant.ratings < 2"> 
									<img src="/design/hungerline-images/happy.png" />Bad
								</span> 
								<span v-if="restaurant.ratings>=2 && restaurant.ratings <3" > 
									<img src="/design/hungerline-images/happy.png" />Good
								</span> 
								<span v-if="restaurant.ratings>=3 && restaurant.ratings <4" > 
									<img src="/design/hungerline-images/happy.png" />Very Good
								</span>
								<span v-if="restaurant.ratings>=4 && restaurant.ratings<=5 " > 
									<img src="/design/hungerline-images/happy.png" />Excellent
								</span>
						   </div>
						</div>
					</div>
				</div>

				<div class="col-12">
					<p>No search results found</p>
				</div>
			</div>
		</div>
				
		<div class="container-sm mb-5" v-else>
			<div class="row">
				<div class="col-xl-4 col-lg-4 col-md-6 mb-3" v-for="restaurant in restaurants" :key="restaurant.r_id">
					<div class="card mb-3 restaurant-card">
						<div class="rest-image">
							<router-link :to="{ name:'restaurant-details',params: {id: restaurant.r_id ,branch_id: restaurant.branch_id } }" >
								<div v-if="restaurant.rest_image" class="restaurant-image"  :style="{ 'background-image': 'url(' + $image_url + restaurant.rest_image + ')' }"></div>
								<div v-else  class="restaurant-image" :style="{ backgroundImage: `url(${NoImageUrl})` }" ></div>
							</router-link>
						</div>
						<div class="card-body">
							<div class="row">
							  	<div class="col">
									<h5 class="card-title" style="text-transform: capitalize;">
										{{ restaurant.rest_name }}
									</h5>
							  	</div>
							  	<div class="col-1 d-flex">
									<img src="/design/hungerline-images/food-delivery.png" style="width: 20px; height: 20px" />
							  	</div>
							  	<div class="col">						
									<p class="dtime">Within {{ restaurant.travel_time }} min</p>
															
							  	</div>
							</div>
							<p class="card-text restaurant-types"><span v-for="type in restaurant.types" :key="type.name">
							  							{{ type.name }}</span>
							</p>
							<div class="row ratings">
							 	<span v-if="restaurant.ratings >= 0 && restaurant.ratings < 1" > 
							 		<img src="/design/hungerline-images/happy.png" />Worst
							 	</span>
								<span v-if="restaurant.ratings>=1 && restaurant.ratings < 2"> 
									<img src="/design/hungerline-images/happy.png" />Bad
								</span> 
								<span v-if="restaurant.ratings>=2 && restaurant.ratings <3" > 
									<img src="/design/hungerline-images/happy.png" />Good
								</span> 
								<span v-if="restaurant.ratings>=3 && restaurant.ratings <4" > 
									<img src="/design/hungerline-images/happy.png" />Very Good
								</span>
								<span v-if="restaurant.ratings>=4 && restaurant.ratings<=5 " > 
									<img src="/design/hungerline-images/happy.png" />Excellent
								</span>
						   </div>
						</div>

					</div>
				</div>
			</div>
		</div> 

		<br>
	</Layout>
</template>

<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";
import NoImageUrl from "@/assets/no-image.png";

export default {
	components: {
		Layout
	},

	data () {
		
		return {
			NoImageUrl,
	      addShow:[],
	      rCheck: 0,
		   restaurants: [],
	      sliders: [],
		   cuisines: [],
	      key:'',
	      key1:'',
	      location:{},
	      sigofood_location:[],
	      sorting:[],
	      sortedArray:[],
	      c_id:'',
		   searchs: [],
	      publicPath: process.env.BASE_URL,
	      style: null,
		}

    
	},
   created() {
		this.style = document.createElement('link')
		this.style.setAttribute('rel', 'stylesheet')
		this.style.setAttribute('href', '/design/restaurants.css')
		document.head.appendChild(this.style)
      this.getToken();
	},

	beforeDestroy() {
		document.head.removeChild(this.style);
	},
	
	mounted() {
		if(this.key) { 
			this.searchRestaurants();
		} else {
			this.fetchRestaurants();
		}
      this.fetchSliders();
	   this.fetchCuisines();
	},

  	methods: {

	 	fetchRestaurants() {
         this.fetchLocation();

         if(this.location) {
            this.getToken();

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "restaurant";             
         
            let formData = new FormData();
            formData.append("latitude", this.location.latitude);
            formData.append("longitude", this.location.longitude);
            formData.append("block_no", this.location.block_no); 

            if(this.c_id){
               formData.append("cuisine_id", this.c_id); 

            } else if(this.$route.params.id){
               formData.append("cuisine_id", this.$route.params.id);

            } else{
                  formData.append("cuisine_id", 0);
            }

            this.$axios
            .post(url, formData, config)
            .then((response) => {
            	if (response.data.status) {
               	var responseData = response.data;
               	console.log(responseData);
               
               	this.restaurants = responseData.data;

               	//this.$swal("", response.data.message, "success");
                     
               } else {
                  this.$swal("", response.data.message, "error");
               }
                  
            })
            .catch((error) => {
               console.log(error);
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
      	} 
   	},
        
		
		sortedItems(val) {

         if(this.addShow.length > 0){
            this.addShow = [] ;
            this.addShow.push(val);
         } else {
            this.addShow.push(val);
         }

         if(this.restaurants){
            console.log(this.restaurants);
       		let restaurants=this.restaurants;

       		if(val=='AZ') {
       			this.restaurants = restaurants.sort((p1, p2) => (p1.rest_name > p2.rest_name) ? 1 : (p1.rest_name < p2.rest_name) ? -1 : 0);
       		}

      		if(val=='Fastest') {
       			this.restaurants = restaurants.sort((p1, p2) => (p1.travel_time > p2.travel_time) ? 1 : (p1.travel_time < p2.travel_time) ? -1 : 0);
       		}

      		if(val=='Rating') {
       			this.restaurants = restaurants.sort((p1, p2) => (p1.ratings < p2.ratings) ? 1 : (p1.ratings > p2.ratings) ? -1 : 0);
       		}

      		if(val=='Recommended') {
       			this.restaurants = restaurants.sort((p1, p2) => (p1.ratings < p2.ratings) ? 1 : (p1.ratings > p2.ratings) ? -1 : 0);
       		}
         }
      },    
	
	
		searchRestaurants() {
        	this.fetchLocation();
		 	this.getToken();

        	let url = "restaurant_search?&latitude=" + this.location.latitude + "&longitude=" + this.location.longitude + "&key=" + this.key + "&block_no=" + this.location.block_no;

        	this.$axios
         .get(url)
			.then((res) => {
          	var responseData = res.data;
        		//   console.log(responseData);
          	this.searchs = responseData.data.restaurants;
        	})
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                  this.$swal("", "Something went wrong 33", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
      },
	 
	 
	 	fetchSliders() {
			this.getToken();

         let url = "sliders?&latitude=" + this.location.latitude + "&longitude=" + this.location.longitude ;

         this.$axios
         .get(url, { headers: { Authorization: "Bearer " + this.token } })

        	.then((res) => {
          	var responseData = res.data;
        		//   console.log(responseData);
          	this.sliders = responseData.data[0];

        		//   console.log(this.sliders);

        	})
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
               	this.$swal("", error.response.statusText, "error");
                        
            	} else if(error.response.status == 500) {
               	this.$swal("", error.response.statusText, "error");

            	} else if(error.response.status == 401) {
               	this.$swal("", error.response.statusText, "error");
               	this.$router.push({ name: "login" });
                        
            	} else {
               	this.$swal("", "Something went wrong 444", "error");
            	}
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
      },
	  
	 
	 	fetchCuisines() {
      	let url = "cuisines" ;
      	this.$axios 
	  		.get(url)

        	.then((res) => {
          	var responseData = res.data;
        		//   console.log(responseData);
          	this.cuisines = responseData.data;
           	console.log(this.cuisines);

        	})
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                        
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                 	this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                        
               } else {
                  this.$swal("", "Something went wrong 55", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
      },  
       
	   
     	getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				console.log(sigofood_user);
				if(sigofood_user.token) {
					this.token = sigofood_user.token;
					this.uid = sigofood_user.uid;
					this.user_id = sigofood_user.user_id;

				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
				
			} else if(localStorage.getItem('sigofood_guest')){
				var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
				console.log(sigofood_guest);
				if(sigofood_guest.token) {
					this.device_token = sigofood_guest.token;
					this.guest_id = sigofood_guest.guest_id;
					
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
      }, 
		  
      fetchLocation() {

			if (localStorage.getItem('sigofood_location')) {
				var sigofood_location =  JSON.parse(localStorage.getItem('sigofood_location'));
				this.latitude = sigofood_location.latitude;
            this.longitude = sigofood_location.longitude;
				this.block_no = sigofood_location.block_no;

				this.location = sigofood_location;

            console.log(this.location);

			} else {
				this.$router.push({ name: "location" });
			}
		}, 
  	}
   
}
</script>


